var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.requirements.length,
            expression: "requirements.length",
          },
        ],
        staticClass: "show-link",
        on: { click: _vm.toggleShow },
      },
      [
        _vm._v(
          "\n    " +
            _vm._s(_vm.show ? "Hide" : "Show") +
            " Regulatory Update History (" +
            _vm._s(_vm.requirements.length) +
            ")\n  "
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show",
          },
        ],
        staticClass: "history-wrapper",
      },
      _vm._l(_vm.requirements, function (hist, index) {
        return _c("div", { key: index }, [
          _c(
            "h2",
            { staticClass: "heading", staticStyle: { "margin-top": "20px" } },
            [_vm._v("\n        " + _vm._s(hist.title) + "\n      ")]
          ),
          _vm._v(" "),
          _c("h2", { staticClass: "date" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.fixDate(hist.publishDate)) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "history-wrapper__content",
            domProps: { innerHTML: _vm._s(hist.content) },
          }),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }